// extracted by mini-css-extract-plugin
export default {"button":"SplitButton_button__lY2sL","menuControl":"SplitButton_menuControl__Sgfxb"};